import React from "react";

function PhotoConsent({ value, onChange }) {
  return (
    <fieldset className="photo-consent">
      <legend>Photo &amp; Video Consent *</legend>

      <p className="photo-consent-description">
        Please select whether you allow OneRoof Beauty to use photos or
        videos of your service for its portfolio and social media marketing.
      </p>

      <label className="photo-consent-option">
        <input
          type="radio"
          name="photoConsent"
          value="yes"
          checked={value === "yes"}
          onChange={() => onChange("yes")}
          required
        />

        <span>
          <strong>Yes, I consent.</strong>
          <br />
          I allow photos and videos of my service to be used for marketing.
        </span>
      </label>

      <label className="photo-consent-option">
        <input
          type="radio"
          name="photoConsent"
          value="no"
          checked={value === "no"}
          onChange={() => onChange("no")}
          required
        />

        <span>
          <strong>No, I do not consent.</strong>
          <br />
          I do not allow photos or videos of my service to be used for marketing.
        </span>
      </label>
    </fieldset>
  );
}

export default PhotoConsent;